import React from "react";
import './footer.css';


import { connect } from "react-redux";
class Footer extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		}
    }

    componentDidMount(){}
	componentWillUnmount(){
    }

    render(){
    console.log('Inside render');
    return(
       
        <div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br/>Powered by FinXpay Solutions Pvt. Ltd.</div>
        
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(Footer);
